<template>
    <div>
        <!-- 吸顶导航 -->
        <van-sticky>
            <van-nav-bar style="background-color: #3f78f6; margin-bottom: 0rem; border: 0" title="" left-text=""
                left-arrow @click-left="onClickLeft">
                <template #title>
                    <span style="color: white;font-size: .4rem;">上传照片</span>
                </template>
                <template #left>
                    <van-icon name="arrow-left" color="white" size="18" />
                </template>
            </van-nav-bar>
        </van-sticky>
        <!-- 中间内容展示 -->
        <section class="van-doc-demo-section">
            <div class="locusItems">
                <van-image fit="fill" :src="require('@/image/user1.png')" />
                <van-image fit="fill" :src="require('@/image/user2.png')" />
            </div>
        </section>
        <!-- 底部tabbar -->
        <van-tabbar v-model="active">
            <van-tabbar-item to="UserInfo">上传须知
                <template #icon="props">
                    <img :src="props.active ? icon1.active : icon1.inactive" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item :to="url">
                <span style="color:#4090fa">上传照片</span>
                <template #icon="props">
                    <img :src="props.active ? icon2.active : icon2.inactive" />
                </template>
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                active: 0,
                value: "",
                shenfen: "",
                tname: "",
                tcode: "",
                student: "",
                url:"",
                page: "",
                loading: false,
                finished: false,
                xiaoqu:"",
                list: [],
                icon1: {
                    active: require('@/image/tab1.png'),
                    inactive: require('@/image/tab1.png'),
                },
                icon2: {
                    active: require('@/image/tab2.png'),
                    inactive: require('@/image/tab2.png'),
                },
            };
        },
        created() {
            this.student = this.$route.query.student;
            this.page = this.$route.query.page;
            this.xiaoqu = this.$route.query.xiaoqu;
            this.url = {
              path: 'UserImg',
              query: {
                student: this.student,
                page: this.page
              }
            }
            console.log("传递过来得学生ID：" + this.student + "和默认轮播定位：" + this.page);
        },
        methods: {   
            onClickLeft() {
                this.$router.push({
                    path: "StudentIndex",
                    query: {
                       student: this.student, xiaoqu: this.xiaoqu,page: this.page
                    }
                });
            },
        },
    };
</script>

<style>
    .van-doc-demo-section {
        box-sizing: border-box;
        min-height: calc(100vh - 1.49333rem);
        padding-bottom: 1.53333rem;
    }
</style>